const fakeData = {};

export default fakeData;
